import React from 'react'
import { FACEBOOK_PRIMARY_COLOR } from '../styles/colors'
import ShareButton, { ShareButtonProps } from './ShareButton'
import { FacebookIcon } from '../Icons'

export const FacebookShareButton: React.FC<ShareButtonProps> = props => (
  <ShareButton title="Share" color={FACEBOOK_PRIMARY_COLOR} {...props} icon={FacebookIcon} />
)
